module.exports = __webpack_public_path__ + "bd77e30e9fbd79a8fcb06a56f8c5f63c.svg";